import { useEffect, useState } from "react";
import {
  getPartnerProfile,
  updatePartnerProfile,
  getPartnerAccount,
  updatePartnerAccount,
} from "../../api/partnerPortalApi";

const PartnerProfilePage = () => {
  const [profile, setProfile] = useState(null);
  const [account, setAccount] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    Promise.all([getPartnerProfile(), getPartnerAccount()]).then(([p, a]) => {
      setProfile(p.profile);
      setAccount(a.account);
    });
  }, []);

  const saveProfile = async () => {
    await updatePartnerProfile(profile);
    setMessage("Profile saved.");
  };

  const saveAccount = async () => {
    await updatePartnerAccount({
      displayName: account.displayName,
      bio: account.bio,
      phone: account.phone,
      websiteUrl: account.websiteUrl,
    });
    setMessage("Business profile saved (pending admin approval for public fields).");
  };

  if (!profile || !account) {
    return <p className="muted panel-card">Loading…</p>;
  }

  return (
    <div className="cv-studio-section">
      {message ? <p>{message}</p> : null}
      <section className="panel-card">
        <h2>Your profile</h2>
        <label className="admin-users-field">
          <span>First name</span>
          <input
            value={profile.firstName || ""}
            onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
          />
        </label>
        <label className="admin-users-field">
          <span>Last name</span>
          <input
            value={profile.lastName || ""}
            onChange={(e) => setProfile({ ...profile, lastName: e.target.value })}
          />
        </label>
        <button type="button" className="midpoint-share-button" onClick={saveProfile}>
          Save profile
        </button>
      </section>
      <section className="panel-card">
        <h2>Business</h2>
        <label className="admin-users-field">
          <span>Display name</span>
          <input
            value={account.displayName || ""}
            onChange={(e) => setAccount({ ...account, displayName: e.target.value })}
          />
        </label>
        <label className="admin-users-field">
          <span>Bio</span>
          <textarea
            value={account.bio || ""}
            onChange={(e) => setAccount({ ...account, bio: e.target.value })}
            rows={4}
          />
        </label>
        <label className="admin-users-field">
          <span>Website</span>
          <input
            value={account.websiteUrl || ""}
            onChange={(e) => setAccount({ ...account, websiteUrl: e.target.value })}
          />
        </label>
        <button type="button" className="midpoint-share-button" onClick={saveAccount}>
          Save business profile
        </button>
      </section>
    </div>
  );
};

export default PartnerProfilePage;
